import { Grid, Stack } from "@mui/material";
import { Show, Tab, TabbedShowLayout, useRecordContext, useRefresh } from "react-admin";
import PromotionalBalanceMetaShow from "./PromotionalBalanceMetaShow";
import TransactionButton from "../Common/TransactionButton";
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import { PromotionalBalanceService } from "../../services/PromotionalBalanceService";
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";
import { useState } from "react";
import PromotionalBalanceRefundDialog from "./PromotionalBalanceRefundDialog";

let promotionalBalanceService = new PromotionalBalanceService();
const RenderCTAButtons = (props: any) => {
  let record = useRecordContext();
  const refresh = useRefresh();
  const [refundDialogOpen, setRefundDialogOpen] = useState(false);
  return (
    <Stack p={2}>
      <Grid container spacing={2} justifyContent="flex-end">
      <Grid item>
            <TransactionButton
                name={"Expire Wallet Cash"}
                color="error"
                onClickHandler={() => {
                    EventBus.emitEvent(EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG, {
                        message: "Expire Wallet Cash",
                        onClose: (confirmed: boolean) => {
                            promotionalBalanceService.expireWalletCash(Number(record?.id)).then((data)=>{
                            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                              message: "Expire Successful",
                              type: CustomSnackbarTypes.SUCCESS,
                            });
                            refresh();
                          }).catch(error=>{
                            console.log(error);
                          })
                        },
                    });
                }}
            />
        </Grid>
        {record?.razorpayOrderId && record?.paymentStatus === 'PAID' && (
          <Grid item>
              <TransactionButton
                  name={"Initiate Refund"}
                  color="warning"
                  onClickHandler={() => setRefundDialogOpen(true)}
              />
          </Grid>
        )}
      </Grid>
      {refundDialogOpen && (
        <PromotionalBalanceRefundDialog
          balanceId={Number(record?.id)}
          open={refundDialogOpen}
          callback={() => setRefundDialogOpen(false)}
        />
      )}
    </Stack>
  );
};

const PromotionalBalanceTabShow = () => {

  return (
    <TabbedShowLayout>
      <Tab label={"Details"}>
        <PromotionalBalanceMetaShow/>
      </Tab>
    </TabbedShowLayout>
  );
};
const PromotionalBalanceShow = (props: any) => {
  return (
    <div>
      <Show {...props} actions={false}>
        <RenderCTAButtons/>
        <PromotionalBalanceTabShow />
      </Show>
    </div>
  );
};
export default PromotionalBalanceShow;